module.exports = __webpack_public_path__ + "img/3ca9d29.png";